/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmailTemplateRequest
 */
export interface CreateEmailTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the CreateEmailTemplateRequest interface.
 */
export function instanceOfCreateEmailTemplateRequest(value: object): value is CreateEmailTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function CreateEmailTemplateRequestFromJSON(json: any): CreateEmailTemplateRequest {
    return CreateEmailTemplateRequestFromJSONTyped(json, false);
}

export function CreateEmailTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'subject': json['subject'],
        'content': json['content'],
    };
}

export function CreateEmailTemplateRequestToJSON(json: any): CreateEmailTemplateRequest {
    return CreateEmailTemplateRequestToJSONTyped(json, false);
}

export function CreateEmailTemplateRequestToJSONTyped(value?: CreateEmailTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'subject': value['subject'],
        'content': value['content'],
    };
}

